/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SrvProceedingCourseEntryRequest } from './SrvProceedingCourseEntryRequest';
import {
    SrvProceedingCourseEntryRequestFromJSON,
    SrvProceedingCourseEntryRequestFromJSONTyped,
    SrvProceedingCourseEntryRequestToJSON,
    SrvProceedingCourseEntryRequestToJSONTyped,
} from './SrvProceedingCourseEntryRequest';

/**
 * 
 * @export
 * @interface SaveSrvProceedingRequest
 */
export interface SaveSrvProceedingRequest {
    /**
     * 
     * @type {Date}
     * @memberof SaveSrvProceedingRequest
     */
    applicationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSrvProceedingRequest
     */
    counselingType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SaveSrvProceedingRequest
     */
    openingDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SaveSrvProceedingRequest
     */
    annulmentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSrvProceedingRequest
     */
    courtId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSrvProceedingRequest
     */
    fileNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSrvProceedingRequest
     */
    trusteeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSrvProceedingRequest
     */
    insolvencyAdministratorId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSrvProceedingRequest
     */
    offeredQuota?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSrvProceedingRequest
     */
    acceptedQuota?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSrvProceedingRequest
     */
    proceedingCosts?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSrvProceedingRequest
     */
    remark?: string | null;
    /**
     * 
     * @type {Array<SrvProceedingCourseEntryRequest>}
     * @memberof SaveSrvProceedingRequest
     */
    courseEntries?: Array<SrvProceedingCourseEntryRequest>;
}

/**
 * Check if a given object implements the SaveSrvProceedingRequest interface.
 */
export function instanceOfSaveSrvProceedingRequest(value: object): value is SaveSrvProceedingRequest {
    return true;
}

export function SaveSrvProceedingRequestFromJSON(json: any): SaveSrvProceedingRequest {
    return SaveSrvProceedingRequestFromJSONTyped(json, false);
}

export function SaveSrvProceedingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveSrvProceedingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationDate': json['applicationDate'] == null ? undefined : (new Date(json['applicationDate'])),
        'counselingType': json['counselingType'] == null ? undefined : json['counselingType'],
        'openingDate': json['openingDate'] == null ? undefined : (new Date(json['openingDate'])),
        'annulmentDate': json['annulmentDate'] == null ? undefined : (new Date(json['annulmentDate'])),
        'courtId': json['courtId'] == null ? undefined : json['courtId'],
        'fileNumber': json['fileNumber'] == null ? undefined : json['fileNumber'],
        'trusteeId': json['trusteeId'] == null ? undefined : json['trusteeId'],
        'insolvencyAdministratorId': json['insolvencyAdministratorId'] == null ? undefined : json['insolvencyAdministratorId'],
        'offeredQuota': json['offeredQuota'] == null ? undefined : json['offeredQuota'],
        'acceptedQuota': json['acceptedQuota'] == null ? undefined : json['acceptedQuota'],
        'proceedingCosts': json['proceedingCosts'] == null ? undefined : json['proceedingCosts'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'courseEntries': json['courseEntries'] == null ? undefined : ((json['courseEntries'] as Array<any>).map(SrvProceedingCourseEntryRequestFromJSON)),
    };
}

export function SaveSrvProceedingRequestToJSON(json: any): SaveSrvProceedingRequest {
    return SaveSrvProceedingRequestToJSONTyped(json, false);
}

export function SaveSrvProceedingRequestToJSONTyped(value?: SaveSrvProceedingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationDate': value['applicationDate'] == null ? value['applicationDate'] : `${value['applicationDate'].getFullYear()}-${String(value['applicationDate'].getMonth()+1).padStart(2,'0')}-${String(value['applicationDate'].getDate()).padStart(2,'0')}`,
        'counselingType': value['counselingType'],
        'openingDate': value['openingDate'] == null ? value['openingDate'] : `${value['openingDate'].getFullYear()}-${String(value['openingDate'].getMonth()+1).padStart(2,'0')}-${String(value['openingDate'].getDate()).padStart(2,'0')}`,
        'annulmentDate': value['annulmentDate'] == null ? value['annulmentDate'] : `${value['annulmentDate'].getFullYear()}-${String(value['annulmentDate'].getMonth()+1).padStart(2,'0')}-${String(value['annulmentDate'].getDate()).padStart(2,'0')}`,
        'courtId': value['courtId'],
        'fileNumber': value['fileNumber'],
        'trusteeId': value['trusteeId'],
        'insolvencyAdministratorId': value['insolvencyAdministratorId'],
        'offeredQuota': value['offeredQuota'],
        'acceptedQuota': value['acceptedQuota'],
        'proceedingCosts': value['proceedingCosts'],
        'remark': value['remark'],
        'courseEntries': value['courseEntries'] == null ? undefined : ((value['courseEntries'] as Array<any>).map(SrvProceedingCourseEntryRequestToJSON)),
    };
}

